import { render, staticRenderFns } from "./pickup-modal.vue?vue&type=template&id=7a995602&lang=true&"
import script from "./pickup-modal.vue?vue&type=script&lang=js&"
export * from "./pickup-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports